import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Anchors from './Pages/Anchors';
import Gools from './Pages/Gools';
import Statigy from './Pages/Statigy';
import Vision from './Pages/Vision';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/anchors" element={<Anchors />} />
          <Route path="/gools" element={<Gools />} />
          <Route path="/statigy" element={<Statigy />} />
          <Route path="/vision" element={<Vision />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;
